import type { MomentProfile } from "../core/director/MomentPresentationResolver";
import { canShowGalleryItem, canShowWish } from "../core/director/EligibilityEngine";
import type { RoomSnapshot } from "../models/contracts";
import type { MemoryStageMode } from "./types";

const affinityRank = { none: 0, low: 1, medium: 2, high: 3, dominant: 4 } as const;

export function shouldUseMemoryAmbient(party: RoomSnapshot, profile: MomentProfile): boolean {
  const manualMemoryWall = !party.tvSettings.automaticDirectorEnabled
    && (party.tvSettings.galleryEnabled || party.tvSettings.wishWallEnabled);
  if (!manualMemoryWall && affinityRank[profile.memoryAffinity] < 2) return false;
  if (manualMemoryWall && party.tvSettings.wishWallEnabled && party.tvPublicContent.wishVisibility === "Live") return true;
  return party.tvPublicContent.gallery.some(item => canShowGalleryItem(item, party))
    || party.tvPublicContent.wishes.some(item => canShowWish(item, party));
}

export function resolveMemoryMode(party: RoomSnapshot, profile: MomentProfile): MemoryStageMode | null {
  const hasGallery = party.tvPublicContent.gallery.some(item => canShowGalleryItem(item, party));
  const hasWishes = party.tvPublicContent.wishes.some(item => canShowWish(item, party));
  if (!hasGallery && !hasWishes) return !party.tvSettings.automaticDirectorEnabled
    && party.tvSettings.wishWallEnabled && party.tvPublicContent.wishVisibility === "Live" ? "wishes" : null;
  if (!hasGallery) return "wishes";
  if (!hasWishes) return "gallery";
  const key = `${party.currentMoment?.key ?? ""} ${party.room.partyType}`.toLowerCase();
  // Gallery and Wish Wall are separate TV experiences. The stage controller
  // alternates them when both are eligible; this is the initial wall.
  void profile;
  void key;
  return "gallery";
}
